import { Eye, Clock, CheckCircle, AlertCircle } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia } from "../../services/api";

export default function PlainteRow({ plainte, onView }) {
  const user = plainte.user;
  const avatar = resolveMedia(user?.profilPicture, defaultAvatar);

  const statusName = plainte.status?.name || plainte.id_status;

  const getStatusClass = (id) => {
    if (id === "S01") return "statusBadgeAttente"; 
    if (id === "S02") return "statusBadgeCours"; 
    if (id === "S03") return "statusBadgeTermine";
    return "statusBadgeDefault";
  };

  return (
    <tr>
      <td>
        <div className="userCell">
          <img src={avatar} className="tableAvatar" alt="avatar" />
          <div>
            <div className="userName">{user?.firstName} {user?.lastName}</div>
            <div className="userSub">@{user?.username}</div>
          </div>
        </div>
      </td>
      <td>
        <div className="plainteSubject">{plainte.subject}</div>
      </td>
      <td className="descriptionCell">
        {plainte.message.substring(0, 60)}...
      </td>
     <td>
        <span className={getStatusClass(plainte.id_status)}>
          {statusName}
        </span>
      </td>
      <td className="center">
        <div className="actions">
          <button className="iconBtn" onClick={() => onView(plainte)}>
            <Eye size={18} />
          </button>
        </div>
      </td>
    </tr>
  );
}